import { Optional } from 'chaika-common-types';
import { CustomFormulaParser } from './CustomFormulaParser';

type Scope = Map<string, any>;

export class FormulaCalculation {
    private parser?: CustomFormulaParser;

    public get isInit(): boolean {
        return !!this.parser;
    }

    public calculate(expr: string): Optional<string | number> {
        return this.parser?.calculate(expr);
    }

    public updateScope(scope: Scope): void {
        if (!this.parser) {
            this.initParser(scope);
        } else {
            this.parser.updateScope(scope);
        }
    }

    public initParser(scope: Scope): void {
        this.parser = new CustomFormulaParser({
            scope,
            fields: [],
            entryCreationTime: new Date(),
        });
    }
}
